import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import HomepageFeaturedCollections from '../../components/HomepageFeaturedCollections';
import HomepageFeaturedRestaurants from '../../components/HomepageFeaturedRestaurants';
import HomepageFeaturedLandingPageTags from '../../components/HomepageFeaturedLandingPageTags';

import {
  clickFeaturedCollection,
  clickFeaturedRestaurant,
} from '../../actions/homepageFeaturedContentActions';

function HomepageFeaturedContent({
  collections,
  restaurants,
  tags,
  onFeaturedCollectionClick,
  onFeaturedRestaurantClick,
}) {
  return [
    <HomepageFeaturedCollections
      key="tags"
      collections={collections}
      onClick={onFeaturedCollectionClick}
    />,
    <HomepageFeaturedRestaurants
      key="restaurants"
      restaurants={restaurants}
      onClick={onFeaturedRestaurantClick}
    />,
    <HomepageFeaturedLandingPageTags key="landing-page-tags" tags={tags} />,
  ];
}

HomepageFeaturedContent.propTypes = {
  collections: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  restaurants: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  tags: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  onFeaturedCollectionClick: PropTypes.func.isRequired,
  onFeaturedRestaurantClick: PropTypes.func.isRequired,
};

export default connect(
  (state) => ({
    collections: state.homepageFeaturedContent.collections,
    restaurants: state.homepageFeaturedContent.restaurants,
    tags: state.homepageFeaturedContent.landingPages,
  }),
  (dispatch) => ({
    onFeaturedCollectionClick: (options) => dispatch(clickFeaturedCollection(options)),
    onFeaturedRestaurantClick: (options) => dispatch(clickFeaturedRestaurant(options)),
  }),
)(HomepageFeaturedContent);
